import React from 'react';
import { Button, FormGroup, Label, Input, Alert } from 'reactstrap';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = { email: '', password: '', selectedTeamId: '' };
  }

  handleCredentialsSubmit = (e) => {
    e.preventDefault();
    const { onLogin } = this.props;
    const { email, password } = this.state;
    if (email && password) {
      onLogin(email, password);
    }
  };

  handleTeamSubmit = (e) => {
    e.preventDefault();
    const { onLogin, pendingCredentials } = this.props;
    const { selectedTeamId } = this.state;
    if (selectedTeamId && pendingCredentials) {
      onLogin(pendingCredentials.username, pendingCredentials.password, selectedTeamId);
    }
  };

  renderTeamSelector() {
    const { teamsList, loginError } = this.props;
    const { selectedTeamId } = this.state;

    return (
      <div className="manage-login">
        <h2 className="mb-2 text-center">Choose Account</h2>
        <p className="text-center text-muted mb-4">Multiple accounts found. Please select one.</p>
        {loginError && <Alert color="danger">{loginError}</Alert>}
        <form onSubmit={this.handleTeamSubmit}>
          <FormGroup>
            <Label for="manage-team">Account</Label>
            <Input
              id="manage-team"
              type="select"
              value={selectedTeamId}
              onChange={(e) => this.setState({ selectedTeamId: e.target.value })}
            >
              <option value="">Select an account...</option>
              {teamsList.map((team) => (
                <option key={team.team_id} value={team.team_id}>
                  {team.team_name}
                </option>
              ))}
            </Input>
          </FormGroup>
          <Button type="submit" color="primary" size="lg" block disabled={!selectedTeamId}>
            Continue
          </Button>
        </form>
      </div>
    );
  }

  render() {
    const { loginError, teamsList } = this.props;

    if (teamsList && teamsList.length > 0) {
      return this.renderTeamSelector();
    }

    const { email, password } = this.state;

    return (
      <div className="manage-login">
        <h2 className="mb-4 text-center">Sign In to Manage Your Subscription</h2>
        {loginError && <Alert color="danger">{loginError}</Alert>}
        <form onSubmit={this.handleCredentialsSubmit}>
          <FormGroup>
            <Label for="manage-email">Email</Label>
            <Input
              id="manage-email"
              type="text"
              value={email}
              onChange={(e) => this.setState({ email: e.target.value })}
              placeholder="Enter your email"
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="manage-password">Password</Label>
            <Input
              id="manage-password"
              type="password"
              value={password}
              onChange={(e) => this.setState({ password: e.target.value })}
              placeholder="Enter your password"
              required
            />
          </FormGroup>
          <Button type="submit" color="primary" size="lg" block>
            Sign In
          </Button>
        </form>
      </div>
    );
  }
}

export default Login;
